import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=a06b86f8&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=ts&"
export * from "./ClientsList.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=a06b86f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b86f8",
  null
  
)

export default component.exports